"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeModal = exports.openModal = exports.buyInOneClickSelector = exports.CLOSE_MODAL = exports.OPEN_MODAL = exports.moduleName = void 0;
var config_1 = require("../config");
var track_event_1 = __importDefault(require("../../../utils/track-event"));
/**
 * Constants
 * */
exports.moduleName = 'buyInOneClick';
var prefix = "".concat(config_1.appName, "/").concat(exports.moduleName);
exports.OPEN_MODAL = "".concat(prefix, "/OPEN_MODAL");
exports.CLOSE_MODAL = "".concat(prefix, "/CLOSE_MODAL");
/**
 * Reducer
 * */
var initialState = {
    action: '',
    fields: {
        email: '',
        phone: '',
    },
    isOpen: false,
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type;
    switch (type) {
        case exports.OPEN_MODAL:
            return __assign(__assign({}, state), { isOpen: true });
        case exports.CLOSE_MODAL:
            return __assign(__assign({}, state), { isOpen: false });
        default:
            return state;
    }
}
exports.default = reducer;
/**
 * Selectors
 * */
var buyInOneClickSelector = function (state) { return state.buyInOneClick; };
exports.buyInOneClickSelector = buyInOneClickSelector;
/**
 * Action Creators
 * */
var openModal = function () {
    (0, track_event_1.default)({
        category: 'closeup',
        action: 'click',
        label: 'one_click_button',
    });
    return {
        type: exports.OPEN_MODAL,
    };
};
exports.openModal = openModal;
var closeModal = function () { return ({
    type: exports.CLOSE_MODAL,
}); };
exports.closeModal = closeModal;
